// createWarehouseReceivingOrder

import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  RECEIVING_ORDERS_INDEX_REQUESTED,
  RECEIVING_ORDERS_INDEX_SUCCESS,
  RECEIVING_ORDERS_INDEX_FAILURE,
  RECEIVING_ORDER_FIND_REQUESTED,
  RECEIVING_ORDER_FIND_SUCCESS,
  RECEIVING_ORDER_FIND_FAILURE,
  RECEIVING_ORDER_CREATE_REQUESTED,
  RECEIVING_ORDER_CREATE_SUCCESS,
  RECEIVING_ORDER_CREATE_FAILURE,
} from '../types';

export const warehouseReceivingOrdersIndexRequested = () => {
  return {
    type: RECEIVING_ORDERS_INDEX_REQUESTED
  }
};

export const warehouseReceivingOrdersIndexSuccess = (warehouseReceivingOrders) => {
  return {
    type: RECEIVING_ORDERS_INDEX_SUCCESS,
    payload: warehouseReceivingOrders
  }
};

export const warehouseReceivingOrdersIndexFailure = () => {
  return {
    type: RECEIVING_ORDERS_INDEX_FAILURE
  }
};


export const warehouseReceivingOrderFindRequested = () => {
  return {
    type: RECEIVING_ORDER_FIND_REQUESTED
  }
};

export const warehouseReceivingOrderFindSuccess = (warehouseReceivingOrder) => {
  return {
    type: RECEIVING_ORDER_FIND_SUCCESS,
    payload: warehouseReceivingOrder
  }
};

export const warehouseReceivingOrderFindFailure = () => {
  return {
    type: RECEIVING_ORDER_FIND_FAILURE
  }
};



export const warehouseReceivingOrdersCreateRequested = () => {
  return {
    type: RECEIVING_ORDER_CREATE_REQUESTED
  }
};

export const warehouseReceivingOrdersCreateSuccess = (warehouseReceivingOrder) => {
  return {
    type: RECEIVING_ORDER_CREATE_SUCCESS,
    warehouseReceivingOrder: warehouseReceivingOrder
  }
};

export const warehouseReceivingOrdersCreateFailure = () => {
  return {
    type: RECEIVING_ORDER_CREATE_FAILURE
  }
};


export const warehouseReceivingOrdersIndex = (signedPayload, purchaseOrderId) => {
  return (dispatch) => {
    dispatch(warehouseReceivingOrdersIndexRequested());

    let endPoint = Config.baseUrl + Config.warehouseReceivingOrders + '/' + Config.purchaseOrder + purchaseOrderId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(warehouseReceivingOrdersIndexSuccess(response.data));
      })
      .catch((error) => {
        dispatch(warehouseReceivingOrdersIndexFailure());
      });
  }
}

export const findWarehouseReceivingOrder = (signedPayload, warehouseReceivingOrderId) => {
  // return (dispatch) => {
  //   dispatch(warehouseReceivingOrderFindRequested());

  //   let endPoint = Config.baseUrl + Config.warehouseReceivingOrder + warehouseReceivingOrderId;
  //   let headers = Object.assign(Config.headers);
  //   headers.payload = signedPayload;

  //   return Axios.get(endPoint, { headers: headers })
  //     .then((response) => {
  //       dispatch(warehouseReceivingOrderFindSuccess(response.data));
  //     })
  //     .catch((error) => {
  //       dispatch(warehouseReceivingOrderFindFailure());
  //     });

  // }
}

export const createWarehouseReceivingOrder = (signedPayload, purchaseOrderId, receivedItems, notes) => {
  return (dispatch) => {
    dispatch(warehouseReceivingOrdersCreateRequested());

    let endPoint = Config.baseUrl + Config.warehouseReceivingOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { purchaseOrderId: purchaseOrderId, receivedItems: receivedItems, notes: notes }, { headers: headers })
      .then((response) => {
        dispatch(warehouseReceivingOrdersCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(warehouseReceivingOrdersCreateFailure());
      });
  }
}


